import { RouterModule, Routes } from '@angular/router';
import { ViewTechnicalserviceComponent } from './components/view-technicalservice/view-technicalservice.component';
import { HomeTechnicalserviceComponent } from './components/home-technicalservice/home-technicalservice.component';
import { ListTechnicalserviceComponent } from './components/list-technicalservice/list-technicalservice.component';
import { ViewTechnicalserviceRepairComponent } from './components/view-technicalservice-repair/view-technicalservice-repair.component';


import { TechnicalServiceGuard } from '../guards/technicalService.guard';



export const TechnicalserviceRouter: Routes = [
    { path: '', component: HomeTechnicalserviceComponent , canActivate: [TechnicalServiceGuard]},
    { path: 'create', component: ViewTechnicalserviceComponent , canActivate: [TechnicalServiceGuard]},
    { path: 'view/:id', component: ViewTechnicalserviceComponent , canActivate: [TechnicalServiceGuard]},
    { path: 'list', component: ListTechnicalserviceComponent },
    { path: 'view/repair/:id', component: ViewTechnicalserviceRepairComponent }
];


// WEBPACK FOOTER //
// ./src/app/technicalservice/technicalservice.router.ts